/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA normal text`)
};

const es_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA texto normal`)
};

const de_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA normaler Text`)
};

const nl_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA normale tekst`)
};

const fr_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA texte normal`)
};

const it_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA testo normale`)
};

const pt_br2_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA texto normal`)
};

const pt_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA texto normal`)
};

const ja_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA 通常テキスト`)
};

const zh_cc_aa_normal = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AA 级 · 正文文字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_aa_normal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_aa_normal(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_aa_normal", locale)
	if (locale === "en") return en_cc_aa_normal(inputs)
	if (locale === "es") return es_cc_aa_normal(inputs)
	if (locale === "de") return de_cc_aa_normal(inputs)
	if (locale === "nl") return nl_cc_aa_normal(inputs)
	if (locale === "fr") return fr_cc_aa_normal(inputs)
	if (locale === "it") return it_cc_aa_normal(inputs)
	if (locale === "pt-BR") return pt_br2_cc_aa_normal(inputs)
	if (locale === "pt") return pt_cc_aa_normal(inputs)
	if (locale === "ja") return ja_cc_aa_normal(inputs)
	return zh_cc_aa_normal(inputs)
};